import boxPropTypes from './box';

import { textVariantTypes, textStyleTypes } from './styleSystem';

export default {
  ...boxPropTypes,
  ...textVariantTypes,
  ...textStyleTypes,
};
